export function checkTheme (theme) {
  const classListOfBody = document.getElementsByTagName('body')[0].classList;
  if (theme) {
    classListOfBody.remove('mode--light')
    classListOfBody.add('mode--dark')
  } else {
    classListOfBody.remove('mode--dark')
    classListOfBody.add('mode--light')
  }
}